import {
    SYNCHRONISATION,
    SYNCHRONISATION_OPEN_TIME,
    SYNCHRONISATION_PAGE,
    SYNCHRONISATION_UPLOADING,
    type SynchronisationActionTypes,
    type SynchronisationState,
} from "../../Actions/Synchronisation/SynchronisationActions";
import { type ShopfrontActions } from "../../Utilities/Generic/ActionsHelper";
import { getOption } from "../../Utilities/Platform/Options/Options";

export default function SynchronisationReducer(
    state: SynchronisationState,
    action: ShopfrontActions<SynchronisationActionTypes>
): SynchronisationState {
    if(typeof state === "undefined") {
        const openTime = getOption("register_open_time");

        return {
            status   : "stopped",
            page     : 0,
            openTime : openTime === "" ? false : openTime,
            uploading: false,
        };
    }

    switch(action.type) {
        case SYNCHRONISATION:
            return {
                ...state,
                status: action.status,
            };
        case SYNCHRONISATION_PAGE:
            return {
                ...state,
                page: action.page,
            };
        case SYNCHRONISATION_OPEN_TIME:
            return {
                ...state,
                openTime: action.openTime === "" ? false : action.openTime,
            };
        case SYNCHRONISATION_UPLOADING:
            return {
                ...state,
                uploading: action.uploading,
            };
        default:
            return state;
    }
}
